import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Modal } from 'antd'
import { WrapperInputSkills } from '../components/EditProfile/Modals/styles'
import { TitleBox } from '../components/EditProfile/SectionProfile/styles'
import { useSave } from '../Context/saveContext'

const { confirm } = Modal

export const useAlertRedirect = () => {
  const navigate = useNavigate()
  const { setIsSaved } = useSave()

  const showDialog = (target, state = {}) => {
    confirm({
      title: null,
      content: (
        <WrapperInputSkills spaceStyle={'flex-start'}>
          <div style={{ margin: '3px' }}>
            <TitleBox>
              {"The changes haven't been saved. Are you sure you want to move out and lose your changes?"}
            </TitleBox>
          </div>
        </WrapperInputSkills>
      ),
      okText: 'Yes',
      cancelText: 'No',

      onOk() {
        setIsSaved(true)
        localStorage.removeItem('local-profile')
        navigate(target, {
          ...state,
          replace: true
        })
      },

      onCancel() {}
    })
  }

  return {
    show: showDialog
  }
}
